/**
 * Sign Up With Firebase
 */
import React, { Component } from 'react';
import Button from '@mui/material/Button';
import { connect } from 'react-redux';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Link } from 'react-router-dom'; 
import LinearProgress from '@mui/material/LinearProgress';
import QueueAnim from 'rc-queue-anim';
import CircularProgress from '@mui/material/CircularProgress';
import {decode as base64_decode} from 'base-64';
import {
	FormGroup,
	Label,
	
} from 'reactstrap';
// components
import { SessionSlider } from 'Components/Widgets';

// app config
import AppConfig from 'Constants/AppConfig';

// redux action
import {
    addPasswordForm, 
} from 'Actions';
import withRouter from 'Util/withRouter';


class SetPassword extends Component {

   state = {      
      pid:'',
      loader:false,
   }

    componentDidMount() {
      let {id} = this.props.params;      
      let urlid=base64_decode(id);
      if(urlid!=0){
            this.setState({ 
               pid:urlid,
            });
      }      
    }

    addHandleSubmit(event){
        this.setState({loader:true });  
        event.preventDefault();
        let { pid } =this.state;
        this.props.addPasswordForm(event, pid).then((data) => {   
            this.setState({loader:false });            
         });
     }


   render() {
      
      const { loading } = this.props;
      const styles = {
         buttonProgress: {
             color: "blue",
             position: 'absolute',
             top: '50%',
             left: '50%',
             marginTop: -15,
             marginLeft: -15,
         },
         wrapper: {
             position: 'relative',
         },
      };
      return (
         <QueueAnim type="bottom" duration={2000}>
            <div className="rct-session-wrapper">
               {loading &&
                  <LinearProgress />
               }
               <AppBar position="static" className="session-header">
                  <Toolbar>
                     <div className="container">
                        <div className="d-flex justify-content-between">
                           <div className="session-logo">
                              <Link to="/">
                                 <img src={AppConfig.appLogo} alt="session-logo" width="110" height="35" />
                              </Link>
                           </div>
                           <div>
                              <Link to="/signin" className="mr-15 text-white">Already have an account?</Link>
                              <Button
                                 component={Link}
                                 to="/signin"
                                 variant="contained"
                                 className="btn-light"
                              >
                                 Sign In
										</Button>
                           </div>
                        </div>
                     </div>
                  </Toolbar>
               </AppBar>
               <div className="session-inner-wrapper">
                  <div className="container">
                     <div className="row row-eq-height">
                        <div className="col-sm-10 col-md-6 col-lg-6" style={{margin:"0 auto"}}>
                           <div className="session-body text-center">
                              <div className="session-head mb-15">
                                 <h2>Set Password</h2>
                              </div>
                              <form autoComplete="off" id="addform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                                 <div className="row">
                                    
                                    <div className="col-md-12">
                                       <FormGroup>
                                          <input type="password" name="newpassword" id="newpassword" className="form-control form-control-alternative" placeholder="New password *" required/>
                                       </FormGroup> 
                                       <FormGroup>
                                          <input type="password" name="confirmpassword" id="confirmpassword" className="form-control form-control-alternative" placeholder="Confirm Password *" required/>
                                       </FormGroup> 
                                    </div>
                                    
                                    <div className="col-md-12">
                                        <div className="form-group">     
                                             <div className="sdds" style={styles.wrapper}>
                                                <button type="submit" className="mr-3 mb-3 btn btn-outline-primary btn-sm" disabled={this.state.loader}>Submit</button> 
                                                {this.state.loader && <CircularProgress size={24} style={styles.buttonProgress} />}
                                             </div>
                                        </div>
                                    </div>
                                 </div>
                              </form>                             
                           </div>
                        </div>                        
                     </div>
                  </div>
               </div>
            </div>
         </QueueAnim>
      );
   }
}

// map state to props
const mapStateToProps = ({ authUser }) => {
   const { loading } = authUser;
   return { loading };
};

export default withRouter(connect(mapStateToProps, {
    addPasswordForm, 
})(SetPassword));
